import { render, staticRenderFns } from "./FormTypeSelect.vue?vue&type=template&id=b1335d48&scoped=true"
import script from "./FormTypeSelect.vue?vue&type=script&lang=js"
export * from "./FormTypeSelect.vue?vue&type=script&lang=js"
import style0 from "./FormTypeSelect.vue?vue&type=style&index=0&id=b1335d48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1335d48",
  null
  
)

export default component.exports